@let stateValue = state();
@if (!stateValue.hidden) {
<div class="navbar">
  <div class="circle">

  </div>

  <nav>
    <p-button routerLink="/ranking" [class.active]="stateValue.activeIndex === 0"
      [style]="{ background: 'none', border: 'none', width: '100%'}" aria-label="Season" icon="pi pi-calendar"
      iconPos="top" label="Saison" size="small" />
    <p-button routerLink="/discover" [class.active]="stateValue.activeIndex === 1"
      [style]="{ background: 'none', border: 'none', width: '100%'}" aria-label="Discover" icon="pi pi-home"
      iconPos="top" label="Découverte" size="small" />
    <p-button routerLink="/account" [class.active]="stateValue.activeIndex === 2"
      [style]="{ background: 'none', border: 'none', width: '100%'}" aria-label="Profile" icon="pi pi-user"
      iconPos="top" label="Profil" size="small" />
  </nav>
</div>
}